/**
 * wagbappro.id 站点全局配置
 */
export default {
  domain: 'https://wagbappro.id',
  siteName: 'WAGBAPPRO.ID',
  logo: require('@/assets/wagbappro/content/01-logo.webp'),
  defaultLocale: 'id',
  languages: [
    { code: 'id', label: 'ID', homePath: '/' },
    { code: 'en', label: 'EN', homePath: '/en/' },
  ],
  nav: [
    { label: 'Home', to: '/', homeAware: true },
    { label: 'Unduh', to: '/unduh-gb-wa/', highlight: true },
    { label: 'Untuk PC', to: '/unduh-gb-whatsapp-untuk-pc/' },
    { label: 'Versi Lama', to: '/wa-gb-versi-lama/' },
    { label: 'Blog', to: '/wa-gb-solusi-masalah/' },
  ],
  footerLinks: [
    { label: 'Disclaimer', to: '/disclaimer/' },
    { label: 'DMCA', to: '/dmca/' },
    { label: 'Privacy Policy', to: '/privacy-policy/' },
  ],
  apk: {
    version: 'v21.30',
    size: '99 MB',
    android: '5.0+',
  },
};
